// import store from "../../store";
// import { BASE_API } from '@/const'
const router = [
  {
    path: "/dokumen",
    name: "dokumen",
    meta: {
      auth: true
    },
    component: () => import("./pages/List.vue")
  },
  {
    path: "/dokumen.pusat",
    name: "dokumen.pusat",
    meta: {
      auth: true
    },
    component: () => import("./pages/LaporanPusat.vue")
  },
  {
    path: "/dokumen/propinsi/:propinsi_id",
    name: "dokumen.propinsi",
    meta: {
      auth: true
    },
    component: () => import("./pages/LaporanPropinsi.vue")
  },
  {
    path: "/dokumen/propinsi/:propinsi_id/kota/:kota_id",
    name: "dokumen.kota",
    meta: {
      auth: true
    },
    component: () => import("./pages/LaporanKota.vue")
  },
  {
    path:
      "/dokumen/propinsi/:propinsi_id/kota/:kota_id/kecamatan/:kecamatan_id",
    name: "dokumen.kecamatan",
    meta: {
      auth: true
    },
    component: () => import("./pages/LaporanKecamatan.vue")
  }
];

export default router;
